import { DialogContentText } from '@mui/material';
import ResponsiveDialog from './ResponsiveDialog';
import { FC } from 'react';

interface ConfirmationDialogProps {
    title: string;
    text?: string;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isLoading?: boolean;
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({ title, text, open, onClose, onConfirm, isLoading }) => {
    return (
        <ResponsiveDialog
            title={title}
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
            isLoading={isLoading}
            isConfirmationDialog={true}
        >
            {text && <DialogContentText>{text}</DialogContentText>}
        </ResponsiveDialog>
    );
};

export default ConfirmationDialog;
